import * as React from 'react';
import classNames from 'classnames';

export interface INestedMenuItemProps {
    /** Opened submenu */
    open?: string;
    /** Submenu toggling */
    setOpenSubMenu?: (id) => void;
    /** ID */
    id?: string;
    /** Class */
    className?: string;
}

const NestedMenuItem: React.FunctionComponent<INestedMenuItemProps> = (props) => {
    const [hasOpenSubMenu, setHasOpenSubMenu] = React.useState<boolean>(false);
    return props.open === null || props.open === props.id ? (
        <li className={classNames('nested-menu__item', props.className)}>
            {React.Children.count(props.children) > 1 ?
                React.Children.map(props.children, (child) => {
                    if (typeof child === 'string' || typeof child === 'number' || child === null) {
                        return child;
                    } else {
                        if (React.isValidElement(child)) {
                            const extendedProps = {
                                open: props.open,
                                id: props.id,
                                setOpenSubMenu: props.setOpenSubMenu,
                                setHasOpenSubMenu,
                                hasOpenSubMenu,
                            };
                            return React.cloneElement(child, extendedProps);
                        }
                        return null;
                    }
                }) : props.children
            }
        </li>
    ) : null;
};

NestedMenuItem.displayName = 'NestedMenuItem';

export default NestedMenuItem;
